'use client';
import { useMediaQuery, useTheme } from '@mui/material';
import { ccStorage } from './storages/local/CookieStorageClient';

const useIsMobile = (init?: boolean) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const viewport = ccStorage.get('viewport');
  return matches || init || viewport === 'm';
};
export default useIsMobile;
